import { Cookies } from 'react-cookie';
import { DISHOP_HUBRISE_ID, HUBRISE_DOMAIN } from '../constants/hubrise';
import store from '../utils/store';
import { sendDeleteRequest } from '../utils/apiService';
import { API_DISCONNECT_HUBRISE } from '../constants';

export const connectToHubrise = redirectUri => {
  const { generalConfig = {}, shop = {} } = store.getState().firebaseRealTime;
  const { name } = generalConfig;
  const { name: shopName } = shop;
  return `${HUBRISE_DOMAIN}/oauth2/v1/authorize?redirect_uri=${redirectUri}&client_id=${DISHOP_HUBRISE_ID}&scope=location[orders.write,customer_list.write,catalog.write]&country=FR&account_name=${name}${shopName !== name ? `&location_name=${shopName}` : ''
    }`;
};

export const disconnectFromHubrise = async () => {
  let { shopId } = store.getState().user;

  if (!shopId) {
    const cookies = new Cookies();
    shopId = cookies.get('shopIdSelected') || cookies.get('shopId');
  }

  if (!shopId) {
    throw new Error('shopId is required to disconnect from Hubrise');
  }

  await sendDeleteRequest(
    API_DISCONNECT_HUBRISE,
    {
      shopId
    },
    {}
  );
};
